import { rankingData } from '@/mocks/home-data';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3 justify-center">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            热度榜单
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 text-center">
          本周最受关注的八卦话题排行榜
        </p>

        <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden">
          {rankingData.map((item, idx) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 p-4 ${
                idx !== rankingData.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div
                className={`w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0 text-sm font-heading ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                      ? 'bg-accent-500 text-background-50'
                      : item.rank === 3
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-background-200 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 truncate">
                  {item.title}
                </h3>
              </div>

              <div className="flex items-center gap-1.5 flex-shrink-0">
                <span className="text-sm font-heading text-primary-500">{item.heat}</span>
                <span className="text-xs text-foreground-400">热度</span>
                {item.trend === 'up' && (
                  <i className="ri-arrow-up-line text-accent-500 text-xs"></i>
                )}
                {item.trend === 'hot' && (
                  <i className="ri-fire-fill text-accent-500 text-xs"></i>
                )}
                {item.trend === 'new' && (
                  <span className="text-[10px] text-accent-500">NEW</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}